<template>
  <div class="goods-entry-wrap">
    <button type="button" class="goods-entry" aria-label="Mở Hộp Quà" @click="openPopup">
      <img :src="goodsIconImg" alt="Hộp Quà" />
    </button>
    <transition name="goods-popup-fade">
      <div v-if="dialogVisible" class="goods-popup-mask" @click="closePopup">
        <div class="goods-popup-panel" :class="{ 'no-bg': phase !== 'result' }" role="dialog" aria-modal="true"
          aria-label="Popup Đạo Cụ" @click.stop>
          <button type="button" class="goods-popup-close" aria-label="Đóng Popup" @click="closePopup">
            <img :src="closeImg" alt="Đóng" />
          </button>
          <img v-if="phase === 'result'" class="goods-popup-bg" :src="goodsBgImg" alt="Popup Đạo Cụ" />
          <div class="goods-popup-content" :class="phase">
            <div v-if="phase !== 'result'" class="goods-preview">
              <div class="goods-popup-info">
                <p class="goods-popup-line">
                  {{ hasChance ? "Bạn có 1 cơ hội rút thưởng" : "Không có cơ hội rút thưởng" }}
                </p>
              </div>
              <button type="button" class="goods-box-btn" :class="{ shaking: phase === 'opening' }"
                :disabled="!canOpen || checking || submitting" @click="openBox">
                <img class="goods-box-img" :src="boxImg" alt="Hộp Quà" />
                <span v-if="checking" class="goods-box-tip">Đang kiểm tra...</span>
                <span v-else-if="!canOpen" class="goods-box-tip">Không có lượt</span>
                <span v-else-if="submitting" class="goods-box-tip">Đang mở hộp...</span>
              </button>
              <div class="goods-popup-info">
                <p class="goods-popup-line">
                  Nạp 1 góinhận 1 lần rút thưởng (giới hạn 1 lần/ngày, tối đa 5 lần), chắc chắn trúng!
                </p>
              </div>
            </div>
            <div v-else class="goods-result">
              <div class="goods-result-card">
                <p class="goods-result-title">Chúc mừng bạn đã nhận được phần thưởng</p>
                <p class="goods-result-code">Code là：{{ rewardCode || "--" }}</p>
                <p class="goods-result-dec">Nhận mã xong nhớ lưu lại nhé, sang ngày sẽ mất đấy!</p>
              </div>
              <button type="button" class="goods-confirm-btn" :disabled="!rewardCode" @click="copyRewardCode">
                Sao chép
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import goodsIconImg from "@/assets/img/activity/goods/goods_icon.png";
import goodsBgImg from "@/assets/img/activity/goods/goods_bg.png";
import boxImg from "@/assets/img/activity/goods/box.png";
import closeImg from "@/assets/img/activity/goods/close.png";

export default {
  name: "ActivityGoods",
  data() {
    return {
      goodsIconImg,
      goodsBgImg,
      boxImg,
      closeImg,
      dialogVisible: false,
      phase: "preview",
      checking: false,
      hasChance: false,
      submitting: false,
      openingTimer: null,
      rewardCode: "",
    };
  },
  computed: {
    canOpen() {
      return this.hasChance;
    },
  },
  beforeDestroy() {
    this.clearOpeningTimer();
  },
  methods: {
    async openPopup() {
      this.clearOpeningTimer();
      this.phase = "preview";
      this.checking = true;
      this.hasChance = false;
      this.submitting = false;
      this.rewardCode = "";
      this.dialogVisible = true;

      try {
        const response = await this.$http.get("/purchase/isRecharge");
        const result = response && response.data ? response.data : response;
        const statusCode = result && result.code;

        if (typeof statusCode === "number" && statusCode !== 200) {
          this.$message.error(result.msg || "Kiểm tra lượt quay thất bại");
          return;
        }

        const data =
          result && result.data && typeof result.data === "object"
            ? result.data
            : result || {};

        this.hasChance =
          data.isRecharge === true ||
          data.isRecharge === 1 ||
          data.isRecharge === "true" ||
          data.isRecharge === "1";
        this.rewardCode = data.code || "";

        if (this.rewardCode) {
          this.hasChance = false;
          this.phase = "result";
        }
      } catch (error) {
        console.error("isRecharge request failed:", error);
        this.$message.error("Kiểm tra lượt quay thất bại");
      } finally {
        this.checking = false;
      }
    },
    closePopup() {
      this.clearOpeningTimer();
      this.dialogVisible = false;
      this.$emit("close");
    },
    clearOpeningTimer() {
      if (this.openingTimer) {
        window.clearTimeout(this.openingTimer);
        this.openingTimer = null;
      }
    },
    async copyRewardCode() {
      if (!this.rewardCode) return;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.rewardCode);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = this.rewardCode;
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        this.$message.success("Sao chép thành công");
      } catch (error) {
        console.error("copy reward code failed:", error);
        this.$message.error("Sao chép thất bại");
      }
    },
    async openBox() {
      if (!this.canOpen || this.phase !== "preview" || this.submitting) return;
      this.submitting = true;
      try {
        const response = await this.$http.get("/purchase/rechargeGift");
        const result = response && response.data ? response.data : response;
        const statusCode = result && result.code;
        if (!result || (typeof statusCode === "number" && statusCode !== 200)) {
          this.$message.warning((result && result.msg) || "Rút thưởng thất bại");
          return;
        }

        const data =
          result && result.data && typeof result.data === "object"
            ? result.data
            : result || {};

        this.hasChance = false;
        this.rewardCode = data.code || "";
        this.phase = "opening";
        this.clearOpeningTimer();
        this.openingTimer = window.setTimeout(() => {
          this.phase = "result";
          this.openingTimer = null;
        }, 1100);
      } catch (error) {
        console.error("draw request failed:", error);
        this.$message.warning("Rút thưởng thất bại");
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.goods-entry {
  position: fixed;
  right: 20px;
  bottom: 136px;
  z-index: 99;
  width: 100px;
  height: 100px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  animation: goodsFadeToLeft 1s ease-in-out;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
    filter: drop-shadow(5px 5px 7px rgba(0, 0, 0, 0.42));
    transition: transform 0.2s ease;
  }

  &:hover img {
    transform: scale(1.08) rotate(-4deg);
  }

  &:active img {
    transform: scale(0.96);
  }
}

.goods-popup-mask {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  box-sizing: border-box;
  background: rgba(2, 10, 18, 0.72);
  backdrop-filter: blur(8px);
}

.goods-popup-panel {
  position: relative;
  width: 360px;
  max-width: 88vw;
  display: flex;
  align-items: center;
  justify-content: center;

  &.no-bg {
    min-height: 320px;
  }
}

.goods-popup-close {
  position: absolute;
  top: -15px;
  right: -8px;
  z-index: 3;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;

  &:active {
    transform: scale(0.92);
  }

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
  }
}

.goods-popup-bg {
  width: 100%;
  max-height: 80vh;
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 18px 32px rgba(0, 0, 0, 0.34));
}

.goods-popup-content {
  position: absolute;
  inset: 0;
  z-index: 1;
  box-sizing: border-box;
  overflow: auto;

  &.preview,
  &.opening {
    padding: 0px 34px;
  }

  &.result {
    padding: 160px 28px 30px;
  }
}

.goods-preview,
.goods-result {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  color: #1b1b1b;
  text-align: center;
}

.goods-popup-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: #fff;
}

.goods-popup-line {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.5;
}

.goods-box-btn {
  position: relative;
  width: 72%;
  max-width: 220px;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.16s ease, filter 0.16s ease;

  &:active {
    transform: scale(0.97);
  }

  &:disabled {
    cursor: not-allowed;
    filter: grayscale(0.15) brightness(0.86);
  }

  &.shaking {
    animation: boxShake 1.1s ease-in-out;
    transform-origin: center bottom;
  }
}

.goods-box-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.24));
}

.goods-box-tip {
  position: absolute;
  left: 50%;
  bottom: -30px;
  transform: translateX(-50%);
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.58);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.goods-result-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 12px 10px;
  box-sizing: border-box;
}

.goods-result-title {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.45;
}

.goods-result-code {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 700;
  word-break: break-all;
}

.goods-result-dec {
  margin: 0;
  font-size: 14px;
  color: red;
}

.goods-confirm-btn {
  width: 60%;
  max-width: 180px;
  height: 40px;
  border: 0;
  border-radius: 999px;
  background: linear-gradient(180deg, #ffd86a 0%, #ffb72b 100%);
  color: #5a3400;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 10px 20px rgba(255, 177, 0, 0.28);

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}

.goods-popup-fade-enter-active,
.goods-popup-fade-leave-active {
  transition: opacity 0.2s ease;
}

.goods-popup-fade-enter,
.goods-popup-fade-leave-to {
  opacity: 0;
}

@keyframes goodsFadeToLeft {
  from {
    opacity: 0;
    transform: translateX(100%);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes boxShake {

  0%,
  100% {
    transform: translateX(0) rotate(0deg);
  }

  15% {
    transform: translateX(-4px) rotate(-5deg);
  }

  30% {
    transform: translateX(5px) rotate(6deg);
  }

  45% {
    transform: translateX(-4px) rotate(-4deg);
  }

  60% {
    transform: translateX(4px) rotate(4deg);
  }

  75% {
    transform: translateX(-2px) rotate(-2deg);
  }
}

@media screen and (max-width: 1000px) {
  .goods-entry {
    bottom: 108px;
    width: 65px;
    height: 65px;
  }

  .goods-popup-panel {
    width: 90vw;
    max-width: 340px;
  }

  .goods-popup-close {
    top: -12px;
    right: -4px;
    width: 30px;
    height: 30px;
  }

  .goods-popup-content.preview,
  .goods-popup-content.opening {
    padding: 0px 28px;
  }

  .goods-popup-content.result {
    padding: 150px 28px 30px;
  }

  .goods-popup-line {
    font-size: 14px;
  }

  .goods-box-btn {
    width: 78%;
    max-width: 210px;
  }

  .goods-result-title {
    font-size: 16px;
  }

  .goods-result-code {
    font-size: 13px;
  }

  .goods-confirm-btn {
    width: 66%;
    max-width: 180px;
  }
}
</style>
